<template>
	<div class="power">
        <el-card>
            <el-button type="success" @click="add()" size="mini" style="margin-bottom:20px" icon="el-icon-circle-plus-outline">添加管理员</el-button>
            <el-input style="margin-left:20px;width:200px" v-model="admin_name" placeholder="请输入管理员" clearable ></el-input>
            <el-button style="margin-left:20px" type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>

            <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="500px">
                <el-row>
                    <el-col :span="6"><span>用户名</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="name" filterable :remote-method="remoteMethod" clearable remote placeholder="请选择" size="mini" style="width:100%" @change="changeUser($event)">
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name+','+item.tell">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br/>

                <el-row>
                    <el-col :span="6"><span>手机</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="tell" placeholder="登录账号" :disabled=true></el-input>
                    </el-col>
                </el-row>
                <br/>

                <el-row>
                    <el-col :span="6"><span>污水污泥猪场</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="org" clearable  multiple placeholder="请选择" style="width:100%">
                            <el-option
                                v-for="item in options1"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br/>

                <el-row>
                    <el-col :span="6"><span>饲料公司</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="siliao" clearable  placeholder="请选择" style="width:100%">
                            <el-option
                                v-for="item in options2"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br/>

                <el-row>
                    <el-col :span="6"><span>环保</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="huanbao" clearable multiple placeholder="请选择" style="width:100%">
                            <el-option
                                v-for="item in options5"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br/>

                <el-row>
                    <el-col :span="6"><span>车辆使用公司</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car" clearable  multiple  placeholder="请选择" style="width:100%">
                            <el-option
                                v-for="item in options3"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br/>

                <el-row>
                    <el-col :span="6"><span>油罐</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="you" clearable multiple placeholder="请选择" style="width:100%">
                            <el-option
                                v-for="item in options4"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br/>

                <el-row>
                    <el-col :span="6"><span>权限</span></el-col>
                    <el-col :span="18">
                        <el-tree
                            ref="tree"
                            @check-change="handleCheckChange"
                            :data="tree"
                            show-checkbox
                            node-key="id"
                            :default-checked-keys="default_tree">
                        </el-tree>
                    </el-col>
                </el-row>
                
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                    <el-button type="primary" @click="submit()" size="mini">确 定</el-button>
                </span>
            </el-dialog>

            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%">
                <el-table-column
                    prop="name"
                    label="管理员">
                </el-table-column>
                <el-table-column
                    prop="tell"
                    label="电话">
                </el-table-column>
                <!-- <el-table-column
                    width="400"
                    label="权限">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.power.indexOf('/index')!=-1">污水污泥   </span>
                        <span v-if="scope.row.power.indexOf('/siliao')!=-1">饲料   </span>
                        <span v-if="scope.row.power.indexOf('/shenhe')!=-1">污水污泥司机审核   </span>
                        <span v-if="scope.row.power.indexOf('/shenhe2')!=-1">饲料司机审核   </span>
                        <span v-if="scope.row.power.indexOf('/huanbaoadmin')!=-1">环保   </span>
                        <span v-if="scope.row.power.indexOf('/cladmin')!=-1">车辆用油   </span>
                        <span v-if="scope.row.power.indexOf('/scadmin')!=-1">生产领用   </span>
                        <span v-if="scope.row.power.indexOf('/qtadmin')!=-1">其他用油   </span>
                        <span v-if="scope.row.power.indexOf('/kucun')!=-1">油量库存   </span>
                        <span v-if="scope.row.power.indexOf('/useradmin')!=-1">管理员维护  </span>
                        <span v-if="scope.row.power.indexOf('/power')!=-1">权限维护</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                    sortable
                    prop="org"
                    label="污水污泥猪场">
                </el-table-column>
                <el-table-column
                    sortable
                    prop="siliao"
                    label="饲料厂">
                </el-table-column>
                <el-table-column
                    sortable
                    prop="huanbao"
                    label="环保">
                </el-table-column>
                <el-table-column
                    sortable
                    prop="car"
                    label="车辆公司">
                </el-table-column>
                <el-table-column
                    sortable
                    prop="you"
                    label="油罐">
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    label="创建时间">
                </el-table-column>
                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope" >
                        <el-button type="primary" size="mini" @click="edit(scope.row)" icon="el-icon-edit">修改</el-button>
                        <el-button type="danger" size="mini" @click="del(scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </el-card>
    </div>
</template>

<script>
    import tree from "../config/tree.js"
    import option from "../config/option.js"
    import { powerList,powerAdd,powerEdit,powerDel,adminList } from '../router/api';
	export default{
		data(){
			return{
                name:'',
                tell:'',
                org:'',
                siliao:'',
                car:'',
                you:'',
                huanbao:'',
                user_id:'',
                dialogVisible: false,
                title:'权限维护',
                tableData:[],
                options:[],
                options1: option.zhuchang,
                options2: option.siliao,
                options3: option.org,
                options4: [],
                options5: option.huanbao,
                default_tree:[],
                tree:tree,
                tree_data:[],
                admin_name:'',
            }
        },
        async mounted() {
            const elementToRemove = '场外加油站';
            this.options4 = option.you.filter(item => item !== elementToRemove);
            this.options4 = option.you;

            await this.getUser()
            await this.getList()
        },
       
		methods: {
            remoteMethod(query) {
                this.getUser(query)
            },
            changeUser(event) {
                this.name = event.split(',')[0]
                this.tell = event.split(',')[1]
            },
            handleCheckChange() {
                const tree = this.$refs.tree;
                const selectedKeys = tree.getCheckedKeys();
                this.tree_data = selectedKeys;
            },

            async getUser(query) {
                adminList({
                    id:'',
                    name:query?query:'',
                }).then(res=> {
                    if(res.code==1) {
                        this.options = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            async getList() {
                powerList({
                    id:'',
                    tell:'',
                    name:this.admin_name,
                }).then(res=> {
                    if(res.code==1) {
                        this.tableData = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },
            
            edit(row) {
                // console.log(row)
                this.org = []
                this.car = []
                this.you = []
                this.huanbao = []
                this.dialogVisible = true
                this.$nextTick(() => {
                    this.name = row.name
                    this.tell = row.tell
                    this.siliao = row.siliao
                    if(row.org!='') {
                        var org_flag = row.org.split(',')
                        org_flag.map(item=>{
                            this.org.push(item)
                        })
                    }
                    if(row.car!='') {
                        var car_flag = row.car.split(',')
                        car_flag.map(item=>{
                            this.car.push(item)
                        })
                    }
                    if(row.you!='') {
                        var you_flag = row.you.split(',')
                        you_flag.map(item=>{
                            this.you.push(item)
                        })
                    }
                    if(row.huanbao!='') {
                        var huanbao_flag = row.huanbao.split(',')
                        huanbao_flag.map(item=>{
                            this.huanbao.push(item)
                        })
                    }
                    this.user_id = row.id,
                    this.$refs.tree.setCheckedKeys([]);
                    this.default_tree = row.power.split(',')
                });
                
            },

            add() {
                this.dialogVisible = true
                this.$nextTick(() => {
                    this.name = ''
                    this.tell = '',
                    this.org = '',
                    this.siliao = '',
                    this.car = '',
                    this.you = '',
                    this.huanbao = '',
                    this.user_id = '',
                    this.tree_data = [],
                    this.$refs.tree.setCheckedKeys([])
                });
            },

            submit() {
                if(this.name==''||this.tree_data==''){
                    this.$message.error('请填写完整信息');
                    return;
                } 
                if(this.user_id) {
                    powerEdit({
                        name: this.name,
                        tell: this.tell,
                        siliao: this.siliao ? this.siliao:'',
                        org: this.org.length == 0 ? '' : this.org,
                        car: this.car.length == 0 ? '' : this.car,
                        you: this.you.length == 0 ? '' : this.you,
                        huanbao: this.huanbao.length == 0 ? '' : this.huanbao,
                        power: this.tree_data,
                        user_id: this.user_id,
                        operate:localStorage.getItem('ws_name'),
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                } else {
                    powerAdd({
                        name: this.name,
                        tell: this.tell,
                        siliao: this.siliao,
                        org: this.org.length == 0 ? '' : this.org,
                        car: this.car.length == 0 ? '' : this.car,
                        you: this.you.length == 0 ? '' : this.you,
                        huanbao: this.huanbao.length == 0 ? '' : this.huanbao,  
                        power: this.tree_data,
                        operate:localStorage.getItem('ws_name'),
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },

            del(row) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    powerDel({
                        id:row.id,
                    }).then(res=> {
                        this.$message.success(res.msg);
                        this.getList()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message.error('取消操作');
                });
            },
        }
    }
</script>